'use strict';

const SELECTOR = '.js-spotlight';
const CLASS_NAMES = {
    available: 'spotlight',
    activated: 'has-spotlight-activated',
    focussed: 'has-spotlight-on'
}

const spotlightItem = element => {
    const targetSelector = element.dataset.spotlight;
    const targets = element.querySelectorAll(targetSelector);

    targets.forEach(target => {
        target.classList.add(CLASS_NAMES.available);

        target.addEventListener('mouseover', () => {
            targets.addClass(CLASS_NAMES.activated);
            target.classList.add(CLASS_NAMES.focussed);
        });

        target.addEventListener('mouseout', () => {
            targets.removeClass(CLASS_NAMES.activated);
            target.classList.remove(CLASS_NAMES.focussed);
        });
    });
}

export function init() {
    const elements = document.querySelectorAll(SELECTOR);

    if (elements.length === 0) {
        return false;
    }

    elements.forEach(element => {
        spotlightItem(element);
    });
}

export default { init }
